export type TAcquisitionErrorToggleAuthorizedUserEventData = {
    // Flag to ensure authorize user knows when to set field state to 'neutral'
    // given event is dispatched from includeXFForm on 'EDIT'
    isDispatchFromVerification?: boolean;
}

export default class AcquisitionErrorToggleAuthorizedUserEvent extends Event {
    public static EventName = 'acquisitionErrorToggle-authorizedUser' as const;
    public isDispatchFromVerification: boolean;

    constructor(authorizedUserEventData: TAcquisitionErrorToggleAuthorizedUserEventData) {
        super(
            AcquisitionErrorToggleAuthorizedUserEvent.EventName,
            {
                cancelable: false,
                bubbles: false,
                composed: true,
            },
        );
        this.isDispatchFromVerification = authorizedUserEventData?.isDispatchFromVerification ?? false;
    }
}